import {Component, computed, inject} from '@angular/core'
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser'
import {StartTextComponent} from './start-text/start-text.component'
import {ConfigService} from '../services/config.service'

@Component({
  selector: 'spb-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  imports: [StartTextComponent]
})
export class HomeComponent {
  public url = computed<SafeResourceUrl>(() =>
    this.sanitizer.bypassSecurityTrustResourceUrl(this.service.site())
  )
  public service = inject(ConfigService)
  protected sanitizer: DomSanitizer = inject(DomSanitizer)


}
